document.addEventListener('turbo:submit-start', (event) => {
    const button = event.target.querySelector("[data-turbo-disable-with]");
    if (button) {
        button.dataset.originalValue = button.value;
        button.value = button.dataset.turboDisableWith;
        button.disabled = true;
    }
});
